import BaseCurdInfo from './BaseCurdInfo'

export default {
  name: 'BaseEditor',
  extends: BaseCurdInfo,
  data () {
    return {
      opened: false,
      operator: '',
      model: this.initModel(),
      refFormName: 'form'
    }
  },
  computed: {
    operatorTip () {
      return this.operator === 1 ? '新增' : '修改'
    }
  },
  methods: {
    onSave () {},
    onOpen (model) {},
    onGetDetail () {},
    beforeSave () {},
    getForm () {
      return this.$refs[this.refFormName]
    },
    open (model) {
      this.onOpen(model)

      if (model) {
        this.operator = 2
        this.getDetail(model)
      } else {
        this.operator = 1
        this.model = this.initModel()
      }

      this.clearFormValid()
      this.opened = true
    },
    initModel () {
      return {}
    },
    afterGetDetail (model) {},
    getDetail (model) {
      this.onGetDetail()

      this.$api[this.apiKey].getDetail(model[this.idKey]).then(data => {
        data = data || {}
        this.model = data
        this.clearFormValid()
        this.afterGetDetail(data)
      }).catch(console.error)
    },
    clearFormValid () {
      let refForm = this.getForm()
      refForm && refForm.resetFields()
    },
    save (callback, idKey) {
      let refForm = this.getForm()

      refForm && refForm.validate(flag => {
        if (!flag) {
          return
        }

        this.beforeSave()

        this.changeLoadStatus(true)

        this.$api[this.apiKey].save(this.model, this.operator).then(data => {
          if (data) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              position: 'bottom-right'
            })
            this.onSave(data)
            callback && callback(data)
          }
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    },
    emitSave (data) {
      this.$emit('save', data)
    },
    saveCallback (data) {
      this.emitSave(data)
      this.close()
    },
    onSaveBtnClick () {
      this.save(this.saveCallback)
    },
    saveContinueCallback (data) {
      this.emitSave(data)
      this.model = this.initModel(this.model)
    },
    onSaveContinueBtnClick () {
      let callback = this.saveContinueCallback

      if (this.operator !== 1) {
        callback = this.saveCallback
      }

      this.save(callback)
      this.clearFormValid()
    },
    onCloseBtnClick () {
      this.close()
    },
    close () {
      this.opened = false
      this.$emit('close')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseEditor.js